import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GlobalMessageUtil } from '@card-software/nexus-utilities';
import { BarcodeScannerService } from '../../../services/barcode-scanner.service';

@Component({
  selector: 'app-qr-scanner-modal',
  templateUrl: './qr-scanner-modal.component.html',
  styleUrl: './qr-scanner-modal.component.scss',
})
export class QrScannerModalComponent {
  @Input() showTrigger = true;
  @Output() isScannedCode = new EventEmitter<string>();
  // QR Scanner properties
  showQrScanner = false;

  constructor(private barcodeScannerService: BarcodeScannerService) {}

  private lastScanTime = 0;

  onQrCodeScanned(code: string): void {
    const now = Date.now();
    // Extract roll number from QR code (remove noise after #)
    const cleanCode = this.barcodeScannerService.extractRollNumber(code);
    // If the last scanned code is the same, apply 4000ms debounce
    if (this.lastScannedCode === cleanCode && now - this.lastScanTime < 4000) {
      return;
    }
    // If the last scanned code is different, allow immediately
    this.lastScanTime = now;
    this.lastScannedCode = cleanCode;
    this.isScannedCode.next(cleanCode);
    this.barcodeScannerService.emitBarcode(cleanCode);
    // Optionally show success message
    // GlobalMessageUtil.info('Info', `Barcode scanned: ${cleanCode}`);
  }

  private lastScannedCode: string | null = null;

  openQrScanner(): void {
    this.showQrScanner = true;
  }

  closeQrScanner(): void {
    this.showQrScanner = false;
  }

  onQrScanError(error: string): void {
    console.error('QR Scan error:', error);
    GlobalMessageUtil.error('Scanner Error', error);
  }
  // #endregion
}
